var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.hidden
    ? _c(
        "div",
        {
          directives: [
            {
              name: "waypoint",
              rawName: "v-waypoint",
              value: { active: true, callback: _vm.trackId, options: {} },
              expression: "{ active: true, callback: trackId, options: {} }"
            }
          ],
          staticClass: "estate-card",
          on: {
            mouseover: function($event) {
              return _vm.mouseOver(_vm.estate.id)
            },
            mouseout: function($event) {
              return _vm.mouseOut(_vm.estate.id)
            }
          }
        },
        [
          _c(
            "a",
            {
              attrs: { href: _vm.estate.detail_url },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.onCardClick.apply(null, arguments)
                }
              }
            },
            [
              _vm.estate.images.length > 1 && _vm.carousel
                ? _c(
                    "my-carousel",
                    {
                      ref: "card_carousel",
                      attrs: {
                        "per-page": 1,
                        "pagination-enabled": false,
                        "navigation-enabled": true,
                        "navigation-next-label": "<span></span>",
                        "navigation-prev-label": "<span></span>",
                        "min-swipe-distance": 2
                      },
                      on: {
                        "navigation-click": _vm.onPageChange,
                        "page-change": _vm.onPageChange
                      }
                    },
                    [
                      _vm._l(_vm.shownImages, function(image, num_image) {
                        return _c("slide", { key: image.id }, [
                          num_image >= _vm.current_page - 1 &&
                          num_image <= _vm.current_page + 1
                            ? _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "lazy",
                                      rawName: "v-lazy:background-image",
                                      value: _vm.imageUrl(
                                        image.url.gallery_media
                                      ),
                                      expression:
                                        "imageUrl(image.url.gallery_media)",
                                      arg: "background-image"
                                    }
                                  ],
                                  staticClass:
                                    "estate-carousel-image crop-center"
                                },
                                [
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "lazy",
                                        rawName: "v-lazy",
                                        value: _vm.imageUrl(
                                          image.url.gallery_media
                                        ),
                                        expression:
                                          "imageUrl(image.url.gallery_media)"
                                      }
                                    ],
                                    attrs: {
                                      alt: _vm.estate.title,
                                      width: "320",
                                      height: "320"
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "estate-card-counter" },
                            [
                              _c("masked-image", {
                                attrs: { src: "/img/icons/images-white.svg" }
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(num_image + 1) +
                                  "/" +
                                  _vm._s(_vm.estate.images.length)
                              )
                            ],
                            1
                          )
                        ])
                      }),
                      _vm._v(" "),
                      _c("slide", [
                        _c(
                          "div",
                          { staticClass: "carousel-cta" },
                          [
                            _c("masked-image", {
                              attrs: {
                                src: "/img/icons/search.svg",
                                width: "24",
                                height: "24"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.trans("labels.cta")))
                            ])
                          ],
                          1
                        )
                      ])
                    ],
                    2
                  )
                : _vm.estate.images.length
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy:background-image",
                          value: _vm.imageUrl(
                            _vm.estate.images[0].url.gallery_media
                          ),
                          expression:
                            "imageUrl(estate.images[0].url.gallery_media)",
                          arg: "background-image"
                        }
                      ],
                      staticClass: "estate-carousel-image crop-center"
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "lazy",
                            rawName: "v-lazy",
                            value: _vm.imageUrl(
                              _vm.estate.images[0].url.gallery_media
                            ),
                            expression:
                              "imageUrl(estate.images[0].url.gallery_media)"
                          }
                        ],
                        attrs: { alt: _vm.estate.title }
                      })
                    ]
                  )
                : _c("img", {
                    staticClass: "estate-carousel-image",
                    attrs: {
                      src: "/img/estate-placeholder.jpg",
                      alt: _vm.estate.title
                    }
                  }),
              _vm._v(" "),
              _c("div", { staticClass: "estate-badges" }, [
                _vm.estate.top
                  ? _c(
                      "span",
                      { staticClass: "estate-badge star-color pl-2 " },
                      [
                        _c(
                          "span",
                          { staticClass: "star" },
                          [
                            _c("masked-image", {
                              attrs: { src: "/img/icons/ico_star.svg" }
                            })
                          ],
                          1
                        ),
                        _vm._v(
                          " " +
                            _vm._s(_vm.trans("labels.top")) +
                            "\n            "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.estate.exclusive
                  ? _c("span", { staticClass: "estate-badge" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.trans("labels.exclusive")) +
                          "\n            "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.estate.best_offer
                  ? _c("span", { staticClass: "estate-badge" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.trans("labels.best_offer")) +
                          "\n            "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.estate.virtual_tour
                  ? _c("span", { staticClass: "estate-badge" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.trans("labels.virtual_tour")) +
                          "\n            "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "estate-card-box-data" },
                [
                  _vm.estate.price_alternative
                    ? _c(
                        "div",
                        { staticClass: "estate-card-current-price-euro" },
                        [
                          _vm._t("estate-price-euro", function() {
                            return [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.estate.price_alternative
                                  )
                                }
                              })
                            ]
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "estate-card-price" },
                    [
                      _vm.estate.price
                        ? _c(
                            "div",
                            { staticClass: "estate-card-current-price" },
                            [
                              _vm._t("estate-price", function() {
                                return [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.estate.price)
                                    }
                                  })
                                ]
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("estate-discount", { attrs: { estate: _vm.estate } }),
                      _vm._v(" "),
                      _vm.showActions
                        ? _c("estate-user-actions", {
                            attrs: {
                              "show-save": _vm.showSave,
                              "show-hide": _vm.showHide,
                              estate: _vm.estate,
                              extLang: _vm.extLang
                            },
                            on: {
                              hide: function($event) {
                                return _vm.hide(_vm.estate)
                              },
                              unsaved: function($event) {
                                return _vm.unsaved(_vm.estate)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "estate-card-titles-container" }, [
                    _c("div", { staticClass: "estate-card-titles" }, [
                      _c(
                        "h3",
                        { staticClass: "estate-card-title" },
                        [
                          _vm._t("estate-title", function() {
                            return [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm._f("capitalize")(_vm.estate.title)
                                  ) +
                                  "\n                        "
                              )
                            ]
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.estate.subtitle
                        ? _c(
                            "h4",
                            { staticClass: "estate-card-subtitle" },
                            [
                              _vm._t("estate-subtitle", function() {
                                return [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm.estate.subtitle
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("estate-card-data", { attrs: { estate: _vm.estate } })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }